export default class LocaleSwitcher {
    constructor($el) {
        this.$el = $el;
        this.$toggle = this.$el.querySelector('.js-langSwitcher-toggle');
        this.isOpen = false;
        this.initListeners();
    }

    initListeners() {
        this.$toggle.addEventListener('click', (e) => {
            e.stopPropagation();
            this.isOpen ? this.close() : this.open();
        });

        // Close on outside click or Escape.
        document.addEventListener('click', (e) => {
            if (this.isOpen && !this.$el.contains(e.target)) {
                this.close();
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.close();
            }
        });
    }

    open() {
        this.isOpen = true;
        this.$el.classList.add('is-open');
        this.$toggle.setAttribute('aria-expanded', 'true');
    }

    close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.$el.classList.remove('is-open');
        this.$toggle.setAttribute('aria-expanded', 'false');
    }
}
